<!--团队业绩-->
<template>
	<div style="height:100%">
		<div class="handleBox flex flex-ai-c">
			<el-page-header @back="goBack" content="团队业绩" style="color:#95A1B9"></el-page-header>
		</div>

		<!-- 表格 -->
		<div class="table" style="height:calc( 100% - 140px )">
			<el-table ref="multipleTable" :data="list" highlight-current-row stripe height="calc( 100% - 40px )" :cell-style="{color:'#515a6e',borderColor:'#E8EAEC'}" :header-cell-style="{background:'#F8F8F9',color:'#515A6E'}">
                <el-table-column prop="name" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="mobile" label="手机号" show-overflow-tooltip></el-table-column>
				<el-table-column label="头像" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-image class="main_pic" :src="getImgUrl(scope.row.headimgurl)" fit="cover" :preview-src-list="[getImgUrl(scope.row.headimgurl)]"></el-image>
					</template>
				</el-table-column>
                <el-table-column prop="nickname" label="昵称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="team_sum" label="业绩" show-overflow-tooltip></el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="paging">
				<el-pagination @current-change="currentChange" @size-change="sizeChange" :current-page="curr" :page-size="row" background layout="total, sizes, prev, pager, next, jumper" :total="count">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],

				curr: 1, //页码
				row: 10, //每页条数
				pages: 1, //总页数
				count: 0, //总条数
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			//团队业绩列表
			getList() {
				this.http.post('/admin/user/getTeamSumList', {
					curr: this.curr,
					row: this.row,
					user_id:this.$route.query.id
				}).then(res => {
					this.list = res.list;
					this.curr = res.curr;
					this.pages = res.pages;
					this.count = res.count;
				});
			},
            //图片路径转换
			getImgUrl: function(url){
				return this.domain + url;
			},
            //返回
			goBack: function(){
				this.$router.go(-1)
			},
			//翻页
			currentChange: function(curr) {
				this.curr = curr;
				this.getList();
			},
			//改变每页条数
			sizeChange: function(row) {
				this.row = row;
				this.getList();
			}
		}
	}
</script>
